/** Returns props to make an HTML element inert (it and its descendents are not interactive and not focusable)
 *  We need this instead of just passing inert to the element because until React 19 React doesn't support inert natively as a prop
 * @param isInert whether to make the element inert or not, useful if the element inert state is based on some condition
 * @returns props to spread into an HTML element
 */
export const getInertProps = (isInert?: boolean) => {
  if (isInert === false) return {};
  return { inert: '' };
};
